import { Separator } from "@/components/Separator.tsx";
import { SuspenseErrorBoundary, type SuspenseErrorBoundaryProps } from "@/modules/error/ErrorFallback.tsx";
import { mcn, type BaseProps } from "@/utils/baseProps.ts";
import type { ReactNode } from "react";

export function LightBlock({
    children,
    title,
    subtitle,
    loadingHeight,
    ...props
}: {
    children: ReactNode;
    title?: ReactNode;
    subtitle?: ReactNode;
} & BaseProps &
    Pick<SuspenseErrorBoundaryProps, "loadingHeight">) {
    return (
        <section {...mcn("lightBlock overflow-hidden", props)}>
            {title != null && (
                <>
                    <h2 className="font-size-heading">{title}</h2>
                    {subtitle != null && <div className="pb-3">{subtitle}</div>}
                    <Separator />
                </>
            )}
            <SuspenseErrorBoundary tags={["admin", "LightBlock"]} loadingHeight={loadingHeight}>
                {children}
            </SuspenseErrorBoundary>
        </section>
    );
}
